import L, { CRS } from 'leaflet';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Map extends Vue {
    private get crs(): CRS {
        return L.CRS.Simple;
    }
}
